export const TicketStatusEnum = {
  CANCELLED: 'Cancelado',
  WAITING: 'Aguardando atendimento',
  ON_GOING: 'Em atendimento',
  FINISHED: 'Concluído',
};

export default TicketStatusEnum;
